/* =============================================================
   WHAYNS DİJİTAL: TASARIM TOKENLARI

   İKİ TEMA, TEK KOD TABANI.
   Tema derleme zamanında seçilir: REACT_APP_TEMA=murekkep | krem
   Varsayılan "murekkep". Sayfaların hiçbiri renk sabiti içermez,
   hepsi buradan besleniyor; tema değiştirmek tek satır.

     murekkep : soğuk kâğıt + neredeyse siyah bloklar. Sert, net, ciddi.
     krem     : sıcak krem + espresso bloklar. Yumuşak, pahalı, sakin.

   Eski palet lacivert + altın + üç yardımcı renkti (mercan, turkuaz, mor).
   Dört ayrı vurgu rengi her bölümü birbirinden koparıyor, sayfa parça
   parça görünüyordu. İki temada da TEK vurgu var.

   ÖNEMLİ: eski isimler (NAVY, CORAL, TEAL, VIOLET) SİLİNMEDİ, yeni ailenin
   içine eşlendi. Böylece 1158 satır inline stil tek tek elden geçirilmeden
   tutarlı hale geldi.

   Kontrast: koyu zeminde ALTIN_PARLAK, açık zeminde ALTIN kullanılır.
   Küçük yazıda (12-13px) ALTIN_KOYU şart, diğer ikisi 4.5:1'i geçmiyor.
   İki paletin de her yazı/zemin çifti hesaplanarak doğrulandı.
   ============================================================= */

/* BLOK NEDEN AYRI BİR TOKEN

   Başta koyu blokların zemini de INK'ti, yani gövde yazısıyla aynı renk.
   Tek renk iki işi birden yapınca çıkmaza giriliyor: blok yumuşasın diye
   rengi açtığınızda kâğıt üstündeki yazılar da soluyor, yazı keskin
   kalsın diye koyulttuğunuzda tam genişlikte siyah şeritler sayfayı
   ikiye kesiyor. İkisi ayrıldı: INK yalnız yazı, BLOK yalnız zemin.
   BLOK_2 blokların İÇİNDEKİ kartlar için bir tık açık olanı. */

const TEMALAR = {
  murekkep: {
    KAGIT: "#FBFAF6", KAGIT_2: "#F2F0E8",
    INK: "#12120F", INK_2: "#3E3E38", INK_3: "#71716A",
    BLOK: "#12120F", BLOK_2: "#1E1E19",
    CIZGI: "#E2E0D6", CIZGI_KOYU: "#2A2A25",
    ALTIN: "#A8792A", ALTIN_PARLAK: "#D2A54A", ALTIN_KOYU: "#6F5119",
    LIGHT_NAVY: "#1E1E19",
    DOKU: false,
  },
  krem: {
    KAGIT: "#FDFBF7", KAGIT_2: "#F6F1E8",
    INK: "#221B14", INK_2: "#4A4034", INK_3: "#6E6152",
    CIZGI: "#E7DFD1", CIZGI_KOYU: "#3A3229",
    // ALTIN iki iş birden yapıyor: dolgu (üstünde koyu yazı, eşik 4.5) ve
    // kâğıt üstünde büyük yazı (eşik 3.0). İlk seçilen #9C7A34 dolgu
    // rolünde 4.25'te kaldı, çünkü krem temanın mürekkebi de açık.
    // Ton sabit tutulup yalnız açıklık oynatıldı: 4.75 / 3.18.
    ALTIN: "#A68237", ALTIN_PARLAK: "#D9B45F", ALTIN_KOYU: "#6B5117",
    BLOK: "#221B14", BLOK_2: "#2E271F",
    LIGHT_NAVY: "#2E271F",
    // İnce film grenli doku: kâğıt hissi verir. Yalnız sabit katmanda,
    // kaydırılan alana asla uygulanmaz (sürekli yeniden çizim yapar).
    DOKU: true,
  },
};

/* Üçüncü tema: krem paletinin aynısı, YALNIZ koyu blokları yumuşak.
   Kahve tonu #392D22'de duruyor; bu, blok üstünde kâğıt yazıyı 12,9:1,
   parlak altını 6,8:1 tutan aralığın ortası. Daha açığa çekilirse yazı
   payı 10:1'in altına iniyor, daha koyuya çekilirse yine şerit gibi
   duruyor. Kartlar için BLOK_2 bir tık açık. */
TEMALAR.krem_yumusak = {
  ...TEMALAR.krem,
  BLOK: "#392D22", BLOK_2: "#453729",
  LIGHT_NAVY: "#453729",
};

/* DIKKAT: bu ifade AYNEN boyle kalmali. Webpack `process.env.REACT_APP_TEMA`
   metnini derleme aninda degerle degistiriyor; basina `typeof process` gibi
   bir koruma konursa tarayicida `process` olmadigi icin kosul false oluyor
   ve tema hic uygulanmiyor. */
export const TEMA_ADI = process.env.REACT_APP_TEMA || "murekkep";
const T = TEMALAR[TEMA_ADI] || TEMALAR.murekkep;

/* --- kâğıt ve mürekkep --- */
export const KAGIT = T.KAGIT;
export const KAGIT_2 = T.KAGIT_2;
export const INK = T.INK;
export const INK_2 = T.INK_2;
export const INK_3 = T.INK_3;
export const CIZGI = T.CIZGI;
export const CIZGI_KOYU = T.CIZGI_KOYU;

/* Koyu blok zeminleri. YAZI RENGİ OLARAK KULLANMAYIN, onun için INK var. */
export const BLOK = T.BLOK;
export const BLOK_2 = T.BLOK_2;

/* --- tek vurgu: markanın altını --- */
export const ALTIN = T.ALTIN;
export const ALTIN_PARLAK = T.ALTIN_PARLAK;
export const ALTIN_KOYU = T.ALTIN_KOYU;
export const DOKU = T.DOKU;

/* --- durum renkleri (yalnız gerçekten durum bildirirken) --- */
export const IYI = "#2C6B4A";
export const KOTU = "#A33241";

/* --- ESKİ İSİMLER: yeni aileye eşlendi --- */
export const GOLD = ALTIN;
export const NAVY = INK;
export const LIGHT_NAVY = T.LIGHT_NAVY;
export const WHITE = KAGIT;
export const CREAM = KAGIT_2;
/* Üç yardımcı renk tek vurguya indi: "ayrı ama bütün" ilkesi. */
export const CORAL = ALTIN_KOYU;
export const TEAL = ALTIN_KOYU;
export const VIOLET = ALTIN_KOYU;

/* --- tipografi --- */
export const DISPLAY = "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif";
export const GOVDE = "'Hanken Grotesk', ui-sans-serif, system-ui, sans-serif";
export const ALINTI = "'Newsreader', Georgia, serif";

/* --- hareket ve biçim --- */
export const CIKIS = "cubic-bezier(0.23, 1, 0.32, 1)";
export const R = "14px";               // köşe yarıçapı, tek değer
export const OLCU = 1200;              // içerik genişliği

export const CONTACT = {
  phone: "+90 850 242 8674",
  email: "destek@whaynsdijital.com",
  address: "İstanbul, Türkiye",
};
